import React from 'react';
export function Footer() {
  return <footer className="bg-navy-dark py-12 px-6 border-t border-white/5" data-id="element-65">
      <div className="max-w-7xl mx-auto flex flex-col items-center" data-id="element-66">
        <img src="https://cdn.magicpatterns.com/uploads/8iq9FdZPWhhg1moFGMfStg/Gemini_Generated_Image_vohteevohteevoht_(1)-Photoroom.png" alt="Oscar Rodriguez Logo" className="h-14 w-auto object-contain mb-6" data-id="element-67" />

        <a href="https://instagram.com/oscarrodriguezm" target="_blank" rel="noopener noreferrer" className="text-gold font-serif text-xl hover:text-yellow-500 transition-colors mb-8" data-id="element-68">
          @oscarrodriguezm
        </a>

        <div className="flex gap-6 text-sm text-gray-light/60" data-id="element-69">
          <a href="#" className="hover:text-gold transition-colors" data-id="element-70">
            Instagram
          </a>
          <span data-id="element-71">|</span>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-72">
            Privacidad
          </a>
        </div>

        <p className="text-xs text-gray-light/40 mt-8" data-id="element-73">
          © 2026 Oscar Rodriguez. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}